import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DisputePatientMatchForm from '~/components/Patient/Identity/Dispute/SubmitDispute/Form';

const DisputePatientMatchModal = ({
  isOpen,
  toggleIsOpen,
}) => (
  <Modal isOpen={isOpen} toggle={toggleIsOpen}>
    <ModalHeader toggle={toggleIsOpen}>Dispute Patient Match</ModalHeader>

    <ModalBody className="p-0">
      <Alert color="warning" className="m-3">
        <FontAwesomeIcon icon="ban" />&nbsp;Incorrect Patient Match
      </Alert>

      <DisputePatientMatchForm
        afterSubmit={toggleIsOpen}
      />
    </ModalBody>
  </Modal>
);

DisputePatientMatchModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleIsOpen: PropTypes.func.isRequired,
};

export default DisputePatientMatchModal;
